import { useEffect, useRef, useState } from "react";
import Navbar from "./Navbar";
import Header from "./Header";
import Footer from "./Footer";
import { clearAllListingFilters } from "@/utils/listingFilterSession";
import styles from "./MainLayout.module.css";

export default function MainLayout({
  children,
  hideHeader = false,
  hideNavbar = false,
  hideFooter = false,
  mobileListing = false,
  headerBackgroundImage,
  headerMobileBackgroundImage,
}) {
  const isHomePage = !hideHeader;
  const [showModuleNav, setShowModuleNav] = useState(!isHomePage);
  const headerRef = useRef(null);

  useEffect(() => {    
    if (isHomePage) {
      clearAllListingFilters();
    }
  }, [isHomePage]);

  useEffect(() => {
    if (!isHomePage) {
      setShowModuleNav(true);
      return undefined;
    }

    setShowModuleNav(false);
    const headerEl = headerRef.current;
    if (!headerEl) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowModuleNav(!entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: "-72px 0px 0px 0px",
      }
    );

    observer.observe(headerEl);

    return () => observer.disconnect();
  }, [isHomePage]);

  return (
    <div>
      {!hideNavbar ? (
        <div className={mobileListing ? styles.hideOnMobile : undefined}>
          <Navbar showModuleNav={showModuleNav} />
          <div
            className={`${styles.navbarOffset} ${
              showModuleNav ? styles.navbarOffsetWithModules : ""
            }`}
            aria-hidden="true"
          />
        </div>
      ) : null}
      {!hideHeader ? (
        <Header
          ref={headerRef}
          backgroundImage={headerBackgroundImage}
          mobileBackgroundImage={headerMobileBackgroundImage}
        />
      ) : null}
      {children}
      {!hideFooter ? (
        <div className={mobileListing ? styles.hideOnMobile : undefined}>
          <Footer />
        </div>
      ) : null}
    </div>
  );
}
